import { ContactType } from "src/app/services/response-models/contacts.response.model";

export class LoadContactTypes {
    public static readonly type = "[Contacts] Load contact types";

    constructor(public payload: ContactType[]) {}
}
